import React from "react";
import { XIcon } from "./Icons";

export const UploadModal = ({
	show,
	uploadedDomains,
	isUploading,
	onClose,
	onFileUpload,
	onProcessUpload,
}) => {
	if (!show) return null;

	return (
		<div
			style={{
				position: "fixed",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: "rgba(0, 0, 0, 0.5)",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				zIndex: 1000,
			}}
		>
			<div
				style={{
					backgroundColor: "var(--openx-surface)",
					borderRadius: "8px",
					padding: "24px",
					width: "90%",
					maxWidth: "500px",
					boxShadow: "var(--openx-shadow-lg)",
				}}
			>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						marginBottom: "20px",
					}}
				>
					<h3
						style={{
							fontSize: "18px",
							fontWeight: "500",
							color: "var(--openx-text-primary)",
						}}
					>
						Upload Domain List
					</h3>
					<button
						onClick={onClose}
						style={{
							background: "none",
							border: "none",
							cursor: "pointer",
							padding: "4px",
						}}
					>
						<XIcon />
					</button>
				</div>

				<div style={{ marginBottom: "16px" }}>
					<p
						style={{
							fontSize: "14px",
							color: "var(--openx-text-secondary)",
							marginBottom: "12px",
						}}
					>
						Upload a CSV file with domain names. Expected format:
					</p>
					<div
						style={{
							backgroundColor: "var(--openx-background)",
							padding: "12px",
							borderRadius: "4px",
							fontFamily: "monospace",
							fontSize: "12px",
							color: "var(--openx-text-primary)",
						}}
					>
						domain
						<br />
						example.com
						<br />
						another-site.com
						<br />
						news-site.org
					</div>
				</div>

				<input
					type="file"
					accept=".csv"
					onChange={onFileUpload}
					style={{
						width: "100%",
						padding: "12px",
						border: "2px dashed var(--openx-border)",
						borderRadius: "6px",
						marginBottom: "16px",
						cursor: "pointer",
					}}
				/>

				<div
					style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}
				>
					<button onClick={onClose} className="btn btn-secondary btn-medium">
						Cancel
					</button>
					<button
						onClick={onProcessUpload}
						className="btn btn-primary btn-medium"
						disabled={uploadedDomains.length === 0 || isUploading}
					>
						{isUploading
							? "Processing..."
							: `Add ${uploadedDomains.length} Domains`}
					</button>
				</div>
			</div>
		</div>
	);
};
